/**
 * Created by jacmai on 3/28/2017.
 */
define(["marionette", "messaging/messenger", "./apiResponseSelectorView"], function (
  Marionette,
  Messenger,
  ApiResponseSelectorView,
) {
  var ApiResponseSelectorController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "apiresponseselector";
      this.region = options.region;
      this._setUpVents();
      this._setUpReqres();
    },
    show: function (apiRequestItem) {
      this.actionItem = apiRequestItem;
      this.view = new ApiResponseSelectorView.apiResponseSelectorView({
        model: apiRequestItem.getTestResults().get("response"),
      });
      this.showRegion(this.view);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "element:selected",
        function (model) {
          //toggle the element that is selected by deselecting the previous model
          if (this.selectedModel) {
            this.selectedModel.set("showEditMenu", false);
          }
          //if the user clicked the same element, or did not select a new element,
          // then deselect it and do not select another element
          if (model && this.selectedModel !== model) {
            this.selectedModel = model;
            this.selectedModel.set("showEditMenu", true);
          } else {
            delete this.selectedModel;
          }
        },
        this,
      );

      Messenger.vent.on(
        "variable:linked",
        function (element, variableId) {
          this.actionItem.addResponseVariable(element, variableId);
        },
        this,
      );

      Messenger.vent.on(
        "variable:unlinked",
        function (variableId) {
          this.actionItem.removeResponseVariable(variableId);
        },
        this,
      );
    },
    _setUpReqres: function () {
      Messenger.reqres.setHandler(
        "unused:action:variables",
        function () {
          //clone the action variables collection and remove any variables already in use by the api request
          var filteredVariables = Messenger.reqres.request("action:variables").clone();
          this.actionItem.getResponseVariables().forEach(function (responseVariable) {
            filteredVariables.remove(responseVariable.conversationVariableId);
          });
          return filteredVariables;
        },
        this,
      );
    },
  });

  return ApiResponseSelectorController;
});
